<div [class.bright]="isBright">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row legend-sec">
                <div class="col-lg-1" [class.blur-form]="isOpenDoctypeModel" *ngIf="frmInvoice">
                    <span class="mat-slider--label">
                        Priority:
                        <small class="font-bold"
                            [ngClass]=" finalValue == 'Normal' ? 'text-success' : finalValue == 'Medium'? 'text-warning' : 'text-danger'">
                            {{ finalValue }}
                        </small>
                        <br />
                        <mat-slider [min]="0" [max]="1" [step]="1" (change)="onSliderInputChange($event)"
                            [attr.role]="null"> </mat-slider>
                    </span>
                </div>
                <!-- <div class="col-lg-6" [class.blur-form]="isOpenDoctypeModel">
                    <span class="form-field-legend">
                        <font color="red">Please refrain from uploading any attachment/Free text fields that contains Sensitive or Personally Identifiable Information (PII) without written consent from the controller (Customer). Consent is mandatory</font>
                    </span>                   
                </div><br> -->
                <div class="col-lg-9" style="margin-left:20px" [class.blur-form]="isOpenDoctypeModel">

                    <span class="form-field-legend">
                        <span style="font-size: 14px;color:#DB0000">* Fields are Mandatory</span>
                    </span>
                    <!-- <span class="form-field-legend paddingcss">
                        <font color="blue"># Fields are Numeric</font>
                    </span> -->
                    <span class="form-field-legend paddingcss">
                        <span style="font-size: 14px;color:green">## Fields are Decimal</span>
                    </span><br>
                    <span class="form-field-legend2">
                        <span style="font-size: 11px;color:#DB0000">Warning Message:Please refrain from
                            uploading any attachment/Free text fields
                            that contains Sensitive or Personally Identifiable Information (PII) without written consent
                            from the controller (Customer). Consent is mandatory</span>
                    </span>

                </div>
                <div class="col-lg-1 text-center doctype-wrap" style="margin-left :700px">
                    <span>
                        <small>Work Item Type</small>
                        <em class="material-icons iconcss" title="Edit"
                            (click)="isOpenDoctypeModel = true;showModal(documentTypeModal,'sm')">edit</em>
                    </span>
                    <br />
                    <span class=" doctype-name">{{ selectedDocumentType.docTypeName }}</span>
                </div>

                <div class="col-lg-2 text-end doctype-wrap" *ngIf="subdocTypeList.length>0">
                    <!-- <mat-form-field appearance="legacy" [style.width.%]="100">
                    <mat-label>Category</mat-label>
                    <mat-select [(ngModel)]="subdocselected" (selectionChange)="changeSubDocumentValue($event)">
                        <mat-option value="0">--Select---</mat-option>
                        <mat-option [value]="subdocType.subdocTypeId"
                            *ngFor="let subdocType of subdocTypeList">
                            {{subdocType.subdocTypeName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->

                    <span>
                        <small>Category</small>
                    </span>
                    <br />
                    <mat-select [(ngModel)]="subdocselected" (selectionChange)="changeSubDocumentValue($event)"
                        (click)="searchText.focus()" (closed)="searchText.value=''" [attr.role]="null">
                        <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off"
                            class="mat-select-search" placeholder="Search Category">
                        <mat-option value="0">--Select---</mat-option>
                        <mat-option [value]="subdocType.subdocTypeId"
                            *ngFor="let subdocType of subdocTypeList| listFilter:{'subdocTypeName':searchText.value}">
                            {{ subdocType.subdocTypeName }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div *ngIf="isCategorySelected" class="form-container" [class.blur-form]="isOpenDoctypeModel">
                <div [formGroup]="frmInvoice" *ngIf="frmInvoice">
                    <div class="row form-control-sec">
                        <div *ngFor="let section of lstSection">
                            <div class="row">
                                <h6 class="advance_search_title">
                                    <span class="main_tab_title">{{section.SECTION_NAME}}</span>
                                </h6>
                            </div>
                            <div class="row">
                                <div *ngFor="let field of section.FIELDS_DETAIL" [ngSwitch]="field.control_type"
                                    class="col-lg-{{ field.control_type == 'TEXTAREA' ? 6 : 3 }}">
                                    <mat-form-field *ngSwitchCase="'TEXTBOX'" [style.width.%]="100">
                                        <mat-label>
                                            {{ field.field_name }}
                                            <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                                            <span
                                                *ngIf="field.validation_type == 'NUMERIC' &&  field.precision_point<=0"
                                                class="field-numeric">#</span>
                                            <span
                                                *ngIf="(field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') &&  field.precision_point>0 "
                                                class="field-decimal">##</span>
                                        </mat-label>

                                        <input matInput
                                            *ngIf="field.value_type=='text' && field.validation_type != 'AMOUNT'"
                                            [type]="field.value_type" [formControlName]="field.db_column_name"
                                            [matTooltip]="field.tool_tip" matTooltipClass="tool_tip_css"
                                            matTooltipPosition="below" [maxlength]="field.max_length"
                                            (keydown.enter)="submitInvoice()" (change)="changeTextFieldValue(field)"
                                            (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                        <input matInput *ngIf="field.value_type=='number'" class="text-end"
                                            (keypress)="onTextBoxKeyPressEvent($event,field)" [type]="field.value_type"
                                            [matTooltip]="field.tool_tip" matTooltipClass="tool_tip_css"
                                            matTooltipPosition="below" [formControlName]="field.db_column_name"
                                            (keydown.enter)="submitInvoice()" (change)="changeTextFieldValue(field)"
                                            (keypress)="omit_special_char($event,field.valid_input_regexp);"
                                            (input) ="limitLength($event, 20)" />

                                        <input matInput *ngIf="field.validation_type == 'AMOUNT'" class="text-end"
                                            (blur)="commonService.formatCurrencyValue($event)" [type]="field.value_type"
                                            [matTooltip]="field.tool_tip" matTooltipClass="tool_tip_css"
                                            matTooltipPosition="below" [formControlName]="field.db_column_name"
                                            (keydown.enter)="submitInvoice()" (change)="changeTextFieldValue(field)"
                                            (keypress)="omit_special_char($event,field.valid_input_regexp);"
                                            (input) ="limitLength($event, 20)" />

                                        <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                            mat-icon-button
                                            (click)="openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                                            <mat-icon [attr.role]="null">search</mat-icon>
                                        </button>
                                        <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                            {{ field.field_name }} is required.
                                        </mat-error>
                                    </mat-form-field>
                                    <div *ngSwitchCase="'DROPDOWN'">
                                        <mat-form-field appearance="legacy" *ngIf="field.is_autocomplete != 1"
                                            [style.width.%]="100">
                                            <mat-label for="{field.db_column_name}">
                                                {{ field.field_name }}
                                                <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                                            </mat-label>
                                            <mat-select [formControlName]="field.db_column_name"
                                                [matTooltip]="field.tool_tip" matTooltipClass="tool_tip_css"
                                                matTooltipPosition="below" (click)="searchText.focus()"
                                                (focus)="searchText.focus()" (closed)="searchText.value=''"
                                                (selectionChange)="changeDropdownFieldValue(field)"
                                                [id]="field.db_column_name" [attr.role]="null">
                                                <input (keydown)="$event.stopPropagation()" type="search" #searchText
                                                    autocomplete="off" class="mat-select-search"
                                                    placeholder="Search {{field.field_name}}">
                                                <mat-option [value]="option.id"
                                                    *ngFor="let option of field.options | listFilter:{'name':searchText.value}">
                                                    {{ option.name }}
                                                </mat-option>
                                            </mat-select>
                                            <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                                mat-icon-button
                                                (click)="$event.stopPropagation();openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                                                <mat-icon [attr.role]="null">search</mat-icon>
                                            </button>
                                            <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                {{ field.field_name }} is required.
                                            </mat-error>
                                        </mat-form-field>

                                        <app-autocomplete matInput *ngIf="field.is_autocomplete == 1" [field]="field"
                                            [formControlName]="field.db_column_name" [defaultValue]="field.field_v"
                                            (callOnAutoCompleteChangedEvent)="callOnAutoCompleteChangedEvent(field)">
                                        </app-autocomplete>
                                    </div>

                                    <mat-form-field *ngSwitchCase="'DATE'" [style.width.%]="100">
                                        <mat-label for="{field.db_column_name}">
                                            {{ field.field_name }}
                                            <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                                        </mat-label>
                                        <input matInput readonly [min]="commonService.minDate"
                                            [formControlName]="field.db_column_name" [matDatepicker]="picker"
                                            [matTooltip]="field.tool_tip" matTooltipClass="tool_tip_css"
                                            matTooltipPosition="below" (keydown.enter)="submitInvoice()"
                                            [id]="field.db_column_name" />
                                        <button *ngIf="getDateFieldValue(field)!==''" mat-button matSuffix
                                            mat-icon-button (click)="clearDateFieldValue(field)">
                                            <mat-icon [attr.role]="null">clear</mat-icon>
                                        </button>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                            {{ field.field_name }} is required.
                                        </mat-error>
                                    </mat-form-field>

                                    <div *ngSwitchCase="'FILE'" [style.width.%]="100">
                                        <mat-hint align="end">
                                            Valid Files:{{invoiceDocValidFileExtensions.join('/ ')}} | Max. Size:
                                            {{invoiceDocFileSize}}MB
                                        </mat-hint>
                                        <span class="text-danger">*</span>
                                        <mat-toolbar (click)="invFileUpload.click()">
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <input type="text" class="form-control fileuploadinput"
                                                        [formControlName]="field.db_column_name" readonly>
                                                    <div class="input-group-btn">
                                                        <span class="fileUpload btn blueupload">
                                                            <span class="upl" id="upload">Upload File
                                                            </span>
                                                            <input [attr.type]="fileControlType" class="upload up"
                                                                id="up" #invFileUpload
                                                                (change)="uploadFileEvt($event, field.db_column_name)"
                                                                hidden accept="image/tif,image/tiff,application/pdf" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-toolbar>
                                    </div>

                                    <mat-form-field *ngSwitchCase="'TEXTAREA'" [style.width.%]="100">

                                        <textarea matInput #fieldComments [formControlName]="field.db_column_name"
                                            rows="3" [maxlength]="field.max_length" [matTooltip]="field.tool_tip"
                                            matTooltipClass="tool_tip_css" matTooltipPosition="below"
                                            [id]="field.db_column_name"
                                            (change)="changeTextFieldValue(field)"></textarea>
                                        <mat-label for="{field.db_column_name}">
                                            {{ field.field_name }}
                                            <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                                        </mat-label>
                                        <mat-hint align="end">
                                            maximum {{ fieldComments.value?.length || 0 }} /{{field.max_length}}
                                            charactors
                                        </mat-hint>
                                        <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                            {{ field.field_name }} is required.
                                        </mat-error>
                                    </mat-form-field>

                                    <div *ngSwitchCase="'CHECKBOX'" [style.width.%]="100">
                                        <mat-checkbox [formControlName]="field.db_column_name">
                                            {{ field.field_name }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="comment-box-main">
                            <div class="row cmnt_sec_h_100">
                                <div class="col-lg-6 col-sm-6 cmnt_sec_h_100">
                                    <label>Comments</label>
                                    <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                                        <span class="textarea_font_sec" title="Show list of restricted keywords"
                                            (click)="showModal(restrictedKeywordModal,'sm')">
                                            <img src="../../../assets/img/transaction/info.png" alt="Info">
                                        </span>
                                        <span class="expand_textarea_sec" (click)="isCommentExpand = !isCommentExpand"
                                            title="Expand">
                                            <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                                        </span>
                                        <span class="textarea_editor_main_sec">
                                            <span class="words_count_limit">
                                                {{wordsTotal}}
                                            </span>
                                        </span>
                                        <span *ngIf="selectedDocumentType.isCommentMandatory==true"
                                            class="comment_mandatory">*</span>
                                        <textarea [(ngModel)]="strComments" (keyup)="function(strComments)"
                                            [formControlName]="invoiceComment" maxlength="1000" title="Comment"
                                            (blur)="checkRestrictedKeywords(invoiceComment)"
                                            [class.invalid]="f.invoiceComment.errors && (f.invoiceComment.touched || submitted)"
                                            class="cmnt_textarea"></textarea>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-sm-12">
                                    <div class="row" *ngIf="showUploadcontroll">
                                        <span class="supportingFileLable">Upload Supporting Documents</span>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6 col-sm-12" *ngIf="showUploadcontroll">
                                            <div class="browsefile_main_section">
                                                <input [attr.type]="fileControlType" #supportfileInput
                                                    id="uploadFileName" title="File Upload"
                                                    (change)="onSelectFile($event)" />
                                                <div class="browse_file_sec">
                                                    <img src="../../../assets/img/transaction/cloud-upload-alt.png"
                                                        alt="Browse File" />
                                                    <span>Drag & Drop Files</span>
                                                </div>
                                                <div class="browser_or_sec">
                                                    <span>Or</span>
                                                </div>
                                                <div class="browse_file_sec">
                                                    <img src="../../../assets/img/transaction/folder-open-solid.png"
                                                        alt="Browse File" />
                                                    <span>Browse File</span>
                                                </div>
                                            </div>
                                            <div class="files_note_sec">
                                                <div class="note">Only {{supportDocValidFileExtensions.join('/ ')}} |
                                                    Max {{supportDocFileSize}}MB
                                                </div>
                                                <div class="files_uploaded_count">
                                                    {{attachmentList.length}} File is Uploaded. <span
                                                        class="view_uploaded_doc" (click)="isShowUploadedDocs = true"
                                                        title="View">View Files</span>
                                                </div>
                                            </div>
                                            <div class="uploaded_files_view_sec">
                                                <div class="uploaded_files_header" *ngIf="isShowUploadedDocs">
                                                    <span>{{attachmentList.length}} files uploaded successfully.</span>
                                                    <span (click)="isShowUploadedDocs = false"><i class="material-icons"
                                                            title="Close">close</i></span>
                                                </div>
                                                <div class="files_list_sec">
                                                    <div class="file_status_sec"
                                                        *ngFor="let file of attachmentList;let i=index">
                                                        <img src="../../../assets/img/transaction/file_uploaded.png"
                                                            class="file_uploaded_icon" alt="File Upload">
                                                        <div class="file_name_sec">
                                                            <div class="file_name_detail">
                                                                <span class="status_file_name">{{file.name}}</span>
                                                                <img *ngIf="!isLoadProgress"
                                                                    (click)="deleteAttachment(i)"
                                                                    src="../../../assets/img/transaction/delete.png"
                                                                    class="files_action_icon file_status_delete"
                                                                    alt="Delete">
                                                            </div>
                                                            <div class="file_status_bar"></div>
                                                        </div>
                                                        <div *ngIf="isLoadProgress" class="d-flex flex-column"
                                                            style="margin-top: 18px;width: 100%;">
                                                            <div>
                                                                <div class="first-progress">
                                                                    <div [ngStyle]="{ 'width.%': file.FileProgress }"
                                                                        class="second-progress"></div>
                                                                </div>
                                                            </div>
                                                            <div class="text-center">
                                                                {{ file.FileProgessSize }} of {{ file.FileSize }}
                                                            </div>
                                                        </div>
                                                        <span *ngIf="!isLoadProgress" class="file_checked_icon">
                                                            <img src="../../../assets/img/transaction/checked.png"
                                                                alt="Check">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-7">
                                                    <div *ngIf="is_Addprocess_In_Create_Work_page==true && lstprocessQueue.length>0"
                                                        class="input-field">
                                                        <mat-form-field appearance="legacy" [style.width.%]="100">
                                                            <mat-label for="next_queue">Next Queue<span
                                                                    class="field-mandatory">*</span></mat-label>
                                                            <mat-select [formControlName]="'nextQueueselected'"
                                                                (click)="searchText.focus()"
                                                                (focus)="searchText.focus()"
                                                                (closed)="searchText.value=''" id="next_queue"
                                                                [attr.role]="null">
                                                                <input type="search"
                                                                    (keydown)="$event.stopPropagation()" #searchText
                                                                    autocomplete="off" class="mat-select-search"
                                                                    placeholder="Search Next Queue">
                                                                <mat-option [value]="queue.process_id"
                                                                    *ngFor="let queue of lstprocessQueue| listFilter:{'process_name':searchText.value}">
                                                                    {{queue.process_name}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="col-lg-12 text-right">
                                                    <button class="btncss" [class.btn_disable]="frmInvoice?.invalid"
                                                        [class.btn_primary]="!frmInvoice?.invalid"
                                                        [disabled]="frmInvoice?.invalid"
                                                        (click)="submitInvoice()">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #documentTypeModal let-modal [attr.role]="null">
    <div class="modal-content" [attr.role]="null">
        <div class="modal-header model_center_header" [attr.role]="null">
            <h5 class="modal-title">Please Select Work Item Type</h5>
            <button type="button" class="close model_close_btn"
                (click)="isOpenDoctypeModel = false;modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                        *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                        <div class="selected-check">{{ docType.docTypeName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #restrictedKeywordModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Keyword Replacement Chart</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div class="table_section">
                    <div class="table-responsive tablecss mt10">
                        <table class="table custom_table">
                            <thead>
                                <tr>
                                    <th>Keywords</th>
                                    <th>Auto Replacement</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of restrictedKeywords">
                                    <td>{{ item.restrict }}</td>
                                    <td>{{ item.replace }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #invoiceSubmittedModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Idea created successfully</h5>
        </div>
        <div class="modal-body custom_modal_body">
            <svg class="svg_sucess_cen" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="linear_suc_cen" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#5f0f7b" />
                        <stop offset="33%" stop-color="#602775" />
                        <stop offset="66%" stop-color="#c5191a" />
                        <stop offset="100%" stop-color="#cc5414" />
                    </linearGradient>
                </defs>
                <path stroke="url(#linear_suc_cen)" class="circle_sucess_cen"
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                <path stroke="url(#linear_suc_cen)" class="tick_sucess_cen" d="M7 12.5L10 15.5L17 8.5"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="model_content" style="text-align: center !important">
                Idea created successfully with URN : <b>{{ createdInvoiceURN}} </b> {{potentialDuplicate}}.
            </div>
            <div class="model_center_btn_part">
                <button type="button" class="btncss me-2 btn_primary" (click)="postSubmitAction('process')">
                    Process
                </button>
                <button type="button" class="btncss me-2 btn_outline_primary"
                    (click)="postSubmitAction('createNewItem')">
                    Create Another Item
                </button>
                <button type="button" class="btncss me-2 btn_outline_primary" (click)="postSubmitAction('dashboard')">
                    Dashboard
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #duplicateInvoiceSubmittedModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Duplicate Invoice</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">

                <div class="outer_table">
                    <div class="scrollable_other_tables">
                        <div class="tableHeaderWrp">
                        </div>
                        <div #scrollableGrid class="scroll_animation">
                            <div class="innner_scroll">
                                <div class="scroll_tables first_table">
                                    <table class="other_tables">
                                        <thead>

                                            <tr>
                                                <ng-container *ngFor="let col of duplicateDataKeys;let i=index">
                                                    <th *ngIf="!changeDuplicateColumnsToHide.includes(col)">{{col}}</th>

                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of lstDuplicateData;let i=index">

                                                <ng-container *ngFor="let column of duplicateDataKeys">
                                                    <!-- <td class="font-bold">{{i+1}}</td> -->
                                                    <td class="font-bold"
                                                        *ngIf="!changeDuplicateColumnsToHide.includes(column) && item.FIELD_NAME.split(',').includes(column)">
                                                        {{item[column]}}
                                                    </td>
                                                    <td [ngStyle]="getCellStyle(column)"
                                                        *ngIf="!changeDuplicateColumnsToHide.includes(column) && !item.FIELD_NAME.split(',').includes(column)"
                                                        (click)="duplicateGridCellClickEventNew(column, item, i)">
                                                        {{item[column]}}
                                                    </td>
                                                </ng-container>


                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <!-- <div class="row">
                    <app-basic-gridview [lstData]="lstDuplicateData" [gridTitle]="" [showExcelDownloadOption]="false"
                        [showSearchOption]="false" [showRecordsPerPageOption]="false" [showPagination]="false"
                        [hyperlinkCols]="['attachment']" [columnsToHide]="changeDuplicateColumnsToHide"
                        (cellClickEvent)="duplicateGridCellClickEvent($event);">
                    </app-basic-gridview>
                </div> -->
                The current transaction appears to be a duplicate transaction. Would you like to move this transaction
                to Potential Duplicate queue?
            </div>
            <div class="model_center_btn_part">

                <button type="button" class="btncss me-2 btn_primary"
                    (click)="modalReference.close();processAsDuplicateInvoice();">
                    Yes
                </button>

                <button type="button" class="btncss me-2 btn_secondary" (click)="modalReference.close()">
                    No
                </button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicateInvoiceSubmittedModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Duplicate Invoice</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">

                <div class="outer_table">
                    <div class="scrollable_other_tables">
                        <div class="tableHeaderWrp">
                        </div>
                        <div #scrollableGrid class="scroll_animation">
                            <div class="innner_scroll">
                                <div class="scroll_tables first_table">
                                    <table class="other_tables">
                                        <thead>

                                            <tr>
                                                <ng-container *ngFor="let col of duplicateDataKeys;let i=index">
                                                    <th *ngIf="!changeDuplicateColumnsToHide.includes(col)">{{col}}</th>

                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of lstDuplicateData;let i=index">

                                                <ng-container *ngFor="let column of duplicateDataKeys">
                                                    <!-- <td class="font-bold">{{i+1}}</td> -->
                                                    <td class="font-bold"
                                                        *ngIf="!changeDuplicateColumnsToHide.includes(column) && item.FIELD_NAME.split(',').includes(column)">
                                                        {{item[column]}}
                                                    </td>
                                                    <td [ngStyle]="getCellStyle(column)"
                                                        *ngIf="!changeDuplicateColumnsToHide.includes(column) && !item.FIELD_NAME.split(',').includes(column)"
                                                        (click)="duplicateGridCellClickEventNew(column, item, i)">
                                                        {{item[column]}}
                                                    </td>
                                                </ng-container>


                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <!-- <div class="row">
                    <app-basic-gridview [lstData]="lstDuplicateData" [gridTitle]="" [showExcelDownloadOption]="false"
                        [showSearchOption]="false" [showRecordsPerPageOption]="false" [showPagination]="false"
                        [hyperlinkCols]="['attachment']" [columnsToHide]="changeDuplicateColumnsToHide"
                        (cellClickEvent)="duplicateGridCellClickEvent($event);">
                    </app-basic-gridview>
                </div> -->
                The current transaction appears to be a duplicate transaction. Would you like to move this transaction
                to Potential Duplicate queue?
            </div>
            <div class="model_center_btn_part">

                <button type="button" class="btncss me-2 btn_primary"
                    (click)="modalReference.close();processAsDuplicateInvoice();">
                    Yes
                </button>

                <button type="button" class="btncss me-2 btn_secondary" (click)="modalReference.close()">
                    No
                </button>
            </div>
        </div>
    </div>
</ng-template>
<div id ="PiiCheckModel" class="cdk-overlay-container" *ngIf="PiiCheckModel">
    <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
    <div class="cdk-global-overlay-wrapper" dir="ltr" style="justify-content: center; align-items: center;">
        <div id="cdk-overlay-2" class="cdk-overlay-pane" style="max-width: 80vw; position: static;">
            <div tabindex="0" class="cdk-visually-hidden cdk-focus-trap-anchor" aria-hidden="true"></div>
            <mat-dialog-content tabindex="-1" aria-modal="true"
                class="mat-dialog-container ng-tns-c73-16 ng-trigger ng-trigger-dialogContainer ng-star-inserted"
                id="mat-dialog-0" role="dialog" style="transform: none;">
                <app-confirmation-dialog _nghost-val-c81 class="ng-star-inserted">
                    <div _ngcontent-val-c81 id="matdialogcontainer_custom" class="mat-dialog-container_custom">
                        <div _ngcontent-val-c81 class="modal_title_sec ng-star-inserted">
                            <h2 _ngcontent-val-c81 class="title">
                                PII Data Agent
                            </h2>
                        </div>
                        <div _ngcontent-val-c81 style="margin-bottom: 30px;" class="ng-star-inserted"></div>
                        <mat-dialog-content _ngcontent-val-c81 class="mat-dialog-content" class="mat-dialog-actions">
                            <p _ngcontent-val-c81>
                                PII information is there
                            </p>
                        </mat-dialog-content>
                        <mat-dialog-actions _ngcontent-val-c81 align="center" class="mat-dialog-actions">
                            <span _ngcontent-val-c81 class="ng-star-inserted">
                                <button _ngcontent-val-c81 type="button" tabindex="1" class="model_ok_btn">
                                    <span _ngcontent-val-c81 class="modal_ok_btn_txt">OK
                                    </span>
                                </button>
                            </span>
                        </mat-dialog-actions>
                    </div>
                </app-confirmation-dialog>
                <p></p>
            </mat-dialog-content>
        </div>
    </div>
</div>